import * as React from 'react';

import { RouteComponentProps } from 'react-router';
import * as RB from 'react-bootstrap';
import * as IntlR from 'react-intl'

import * as DTO from '../service/DTOs';
import * as Session from '../service/Session';
import * as API from '../service/apisvc';
//import { NumberFormat } from 'react-number-format';
import { Typeahead, AsyncTypeahead } from 'react-bootstrap-typeahead';
import { SecurityListItem } from './view/LookupListItems';
import * as TF from '../service/tradeflow';
import * as Actions from '../service/Actions';
import * as Dispatch from '../service/Dispatcher';

import Cleave from 'cleave.js/react';
import moment from 'moment';

import { AppConfig } from '../service/AppState'
import { ContragentPopoverInfo } from './view/helpers/ContragentPopoverInfo'
//import { TextChat } from './TextChat';
import { ImpactorChat } from '../components/impactor/ImpactorChat';

//import * as MD from 'react-md'
import { LineSpinner } from './shared/effects/LineSpinner';

import { PrivateChatIcon } from '../components/shared/effects/Icons';



import 'isomorphic-fetch';
import { DoMRowContextLimits, initialState_DoMRowContextLimits } from '../components/DoMRowContextLimits';
import { PersonalState } from '../service/Session';


export interface DoMRowDetailState {
    user?: Session.UserState,
    syshdr: DTO.SystemHeader,

    instrument?: DTO.InstrumentHead,
    //iavail?: DTO.InstrumentAvailabilityDto,
    domrecord?: DTO.DomRecord,

    form?: DTO.NewOrderAccept;
    records?: DTO.RecordOrder[];
    isSubmitting?: boolean;
    submitted?: boolean;
    result?: string;
    result_is_ok?: boolean;
    errors?: any;
    selectedOrder?: DTO.RecordOrder;
    loading: boolean;
    processing?: boolean;
    selected_locatorId?: string;

    //selectedSec?: DTO.Security;
}

type NewOrderProps = DoMRowDetailState & { tradesession?: DTO.TradeSessionDto; }& { xsrfToken?: string } & {
    onNewDealSubmitted?: (data: DTO.OrderAccept) => {} };

const initialForm: DTO.NewOrderAccept = {
    orderid: '0',
    sum: 0
    //discount: 0
}

const initialState: DoMRowDetailState = {
    user: { identityState: Session.AnonimousIdentityState },
    syshdr: { hasfreshchanges: false, sstamp: '' },
    instrument: {
        id:0, fiid: '', name: '', pos: 0, currency: { id: 0, name: '', shortname: '' }, duration: { id: 0, name: '' },
        iavail: { fiid: '', perms: [], readonly: false, suspended: false, tradeopen: false }
    },
    //iavail: { fiid: '', perms: [], readonly: false, suspended: false, tradeopen: false },
    form: initialForm,
    isSubmitting: false,
    submitted: false,
    loading: false,
    errors: null
    //selectedSec: undefined
}

export class DoMRowDetailsComponent extends React.Component<NewOrderProps, DoMRowDetailState> {    
    constructor(props: NewOrderProps) {
        super(props);
        //this.state = { ...initialState, ...props };
        this.state = { ...initialState };
    }    

    componentWillReceiveProps(nextProps: NewOrderProps) {
        if (this.state.form !== nextProps.form && nextProps.form) {
            this.setState({ form: nextProps.form });
            //this.setState(nextProps)
        }
    }

    componentDidMount() {
        TF.CommandProcessBinding(this, { type: 'COMMAND.SelectDoMRecord', delegate: this.processSelectDoMRecord });
    }

    processSelectDoMRecord = (cmd: TF.SelectDoMRecordCommand) => {
        //console.log('processSelectDoMRecord');
        //console.log(cmd);
        
        if (this.refs.cmpDoMDetailsRef) {
            this.setState({ instrument: cmd.instrument, domrecord: cmd.record });

            if (this.state.form && cmd) {
                //var _form = this.state.form;
                this.setState({
                    form: { orderid: '', sum: 0}
                });

                if (cmd.record) {
                    this.getOrders(cmd.record).then(({ records }) => {
                        //let recs: any[] = records;
                        this.setState({ records });
                    });
                    
                }
                //this.getOptions(_form.securityid)
                //    .then(({ options }) => {
                //        let opts: any[] = options;
                //        if (opts && opts.length == 1) {
                //            this.typeahead._handleChange(opts);
                //            //this.handleSecSelect(opts);
                //        }
                //    });
            }
        }

        return {};

    }


    //handleFiidSelect = (eventKey: any) => {
    //    //this.setState({ fiid: eventKey });
        
    //    if (this.state.form)
    //        this.setState({ form: { ...this.state.form, ...{ fiid: eventKey} } });
    //}

    //handleSecSelect = (sec: DTO.Security[]) => {

    //    if (this.state.form) {
    //        if (sec && sec.length > 0)
    //            this.setState({ form: { ...this.state.form, ...{ securityid: sec[0].secid } }, selectedSec: sec[0] });
    //        else
    //            this.setState({ form: { ...this.state.form, ...{ securityid: '' } }, selectedSec: undefined });
    //    }

    //}

    handleChange = (e: any) => {
        //console.log(e);

        if (this.state.form) {
            var _form = { ...this.state.form, ...{ [e.target.name]: e.target.rawValue } };
            this.setState({ form: _form });
        }
    }

    getOrders = (record: DTO.DomRecord) => {

        return (async () => {
        try {
            const xsrf = this.props.xsrfToken ? this.props.xsrfToken : '';
            const response: Response = await fetch(API.apiUrl(API.API_DOMRECORDDETAIL_URL), {
                method: 'POST',
                credentials: 'include',
                headers: new Headers({
                    ...
                    {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': xsrf || ''
                    },
                    ...API.authHeader()
                }),
                body: JSON.stringify(record.manipulation)
            });

            const statusCode = response.status;

            if (response.ok) {
                const resp_data = await response.json();
                const data = resp_data as DTO.MessageDto<DTO.OrderBookRecords>;

                if (data && data.result) {
                    return { records: data.result.ordbook_records };
                    //this.setState({ records: data.result.ordbook_records })
                }
                else {
                }

                return { records: undefined };
            } else {
                //this.setState({ records: [] });
                console.log('Error fetching DoM Details');

                let _error: string | any[] | undefined;
                const data = await response.json() as DTO.ErrorMessageDto<DTO.ManipulationAction<string>>;
                _error = data.validation;
                console.log(_error);
                return { records: undefined };
            }
        }
        catch (e) {
            //this.setState({ records: [] });
            console.log('Error fetching DoM Details');
            console.log(e.message);
            return { records: undefined };
        }
        })();
    }

    dispatch(action: NewDealAction) {
        this.setState(function (state, props) {
            return stateforwarder(state, action);
        });
    }

    submitDealForm = (form: DTO.NewOrderAccept) =>  {

        return (async () => {

            //if (1 == 1) {
            //    this.dispatch({ type: 'RESET_NEW_DEAL_FORM' });
            //    return;
            //}
            

            this.dispatch({ type: 'SUBMIT_NEW_DEAL_FORM', payload: form });

            try {
                const xsrf = this.props.xsrfToken;
                //const formData = Object.entries(form).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
                //console.log('submitDealForm');
                //console.log(formData);
                //const response: Response = await fetch(API.apiUrl(API.API_NEW_ACCEPT_URL), {
                //    method: 'POST',
                //    credentials: 'include',
                //    redirect: 'error',
                //    headers: new Headers({
                //        ...{
                //            'X-XSRF-TOKEN': xsrf || '',
                //            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                //        },
                 //       ...API.authHeader()
                 //   }),
                 //   body: formData
                //});

                const response: Response = await fetch(API.apiUrl(API.API_NEW_ACCEPT_URL), {
                    method: 'POST',
                    credentials: 'include',
                    headers: new Headers({
                        ...
                        {
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': xsrf || ''
                        },
                        ...API.authHeader()
                    }),
                    body: JSON.stringify(form)
                });



                const statusCode = response.status;
                if (statusCode === 201) {
                    const data = await response.json() as DTO.MessageDto<DTO.OrderAccept>;
                    this.props.onNewDealSubmitted ? this.props.onNewDealSubmitted(data.result) : '';

                    this.dispatch({ type: 'NEW_DEAL_RECIEVED', payload: { form: data.result, result: 'Сделка успешно акцептована' } });

                    this.handleSelectContext(undefined, undefined);

                    this.processSelectDoMRecord({ instrument: this.state.instrument, record: this.state.domrecord });

                    setTimeout(() => {
                        this.dispatch({ type: 'RESET_NEW_DEAL_FORM' });
                    }, 2000);
                }
                else if (statusCode === 422) {
                    let err = await response.json() as { newOrder4CreationDto:string[]};
                    //console.log(err);
                    this.dispatch({ type: 'NEW_DEAL_FORM_ERROR', payload: { form, errors: err, result: err.newOrder4CreationDto[0] || 'Введенные данные некорректны' } });
                }
                else {
                    this.dispatch({ type: 'NEW_DEAL_FORM_ERROR', payload: { form, errors: response.json(), result: response.statusText } });
                }
            } catch (error) {
                //alert(error);
                this.dispatch({ type: 'NEW_DEAL_FORM_ERROR', payload: { form, result: error.message || 'Произошла ошибка' } });
            }
        })();

    }

    submit = (event: React.FormEvent<RB.Form>) => {
        if (this.state.form) {
            this.submitDealForm(this.state.form);
            event.preventDefault();
        }
    }


    handleBuyAll(locator: { locatorId: string } | undefined) {
        let manipulation: DTO.ManipulationAction<string> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_REPEAL,
            locatorId: locator ? locator.locatorId : undefined,
            payload: undefined
        }

        //return Actions.orderActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatch);
    }

    handleSellAll(locator: { locatorId: string } | undefined) {
        let manipulation: DTO.ManipulationAction<string> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_REPEAL,
            locatorId: locator ? locator.locatorId : undefined,
            payload: undefined
        }

        //return Actions.orderActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatch);
    }


    handleSelectContext(locatorId?: string, record?: DTO.RecordOrder) {
        this.setState({
            selected_locatorId: locatorId
        });


        let uiCtx: DTO.UserInteractionContext = {
            selected_cmp: this,
            selected_locatorId: locatorId
        }
        //console.log('handleSelectContext');
        //console.log(record);
        

        this.setState({ selectedOrder: record });

        //orderid: string;
        //sum: number;

        TF.PublishCommand('COMMAND.UI.UserInteractionCtx', uiCtx);

        if (locatorId && record) {
            //console.log('handleSelectContext 2');
            //console.log('record.manipulation.locatorId = ' + record.manipulation.locatorId);
            this.setState({ form: { orderid: record.manipulation.locatorId, sum: record.sumavail } });
            let nOrder: DTO.NewOrder = record.proto;

            TF.PublishCommand('COMMAND.NewOrderFromTemplate', nOrder);
        }
    }





    public render() {
        let contents = this.state.loading
            ? <p><em>Processing...</em></p>
            : (this.state.records ? this.renderOrdersTable(this.state.records, this.state.processing ? this.state.processing : false) : this.renderOrdersTable([], false));

        let filterCnt = 'Processing...';

        let hdrContent = <div><b>Детализация по ставке</b></div>

        let hdrContent2 = null;
        if (this.state.instrument && this.state.instrument.fiid.length > 0) {
            if (this.state.domrecord && this.state.domrecord.rate) {
                let _rate = (this.state.domrecord.rate / 100.0);
                hdrContent2 = <div>Ставка: <IntlR.FormattedNumber value={_rate} style="percent" minimumFractionDigits={2} maximumFractionDigits={2}/>, {this.state.instrument.name}</div>
            }
            else {
                hdrContent2 = <div>{this.state.instrument.name}</div>
            }
        }
        else {
            hdrContent2 = <div>[Выберите инструмент]</div>
        }

        let canTake = false;
        let buyCaption = 'Продать';
        let takeBntEnabled = false;
        let showData = this.state.instrument ? (this.state.instrument.iavail ? (this.state.instrument.iavail.tradeopen || this.state.instrument.iavail.suspended ? true : false) : false) : false;
        let canTrade = this.state.instrument ? (this.state.instrument.iavail ? (this.state.instrument.iavail.tradeopen ? true : false) : false) : false;

        if (this.state.selectedOrder ) {
            canTake = this.state.selectedOrder.manipulation.perms.includes(DTO.MANIPULATION_PERM_TAKE);
            buyCaption = this.state.selectedOrder.lottype == 'buy' ? 'Продать' : 'Купить';
            if (canTake && canTrade && !this.state.isSubmitting && this.state.form && this.state.form.sum > 0 && this.state.form.sum >= this.state.selectedOrder.minlot && this.state.form.sum <= this.state.selectedOrder.sumavail)
                takeBntEnabled = true;
        }        
        
        
        let acceptInfo1 = (this.state.instrument && this.state.selectedOrder) ?
            <RB.Row style={{ paddingTop: '2px' }}>
                <RB.Col sm={3} >
                    {canTake ? 'Акцепт по ставке: ' : 'Лот по ставке:'}
                </RB.Col>
                <RB.Col sm={2} style={{ textAlign: 'right'}}>
                    <IntlR.FormattedNumber value={this.state.selectedOrder.rate / 100.0} style="percent" minimumFractionDigits={2} maximumFractionDigits={2} />
                </RB.Col>
                <RB.Col sm={2} >
                    {this.state.selectedOrder.lottype}
                </RB.Col>
                <RB.Col sm={5} >
                    {this.state.instrument.name}                    
                </RB.Col>
             </RB.Row>
            :
            <RB.Row style={{ paddingTop: '2px' }}>
                <RB.Col sm={12}>
                    {'[Выберите лот]'}
                </RB.Col>
            </RB.Row>

        let minLotMark = null;

        if (this.state.form && canTake && this.state.selectedOrder) {
            if (this.state.form.sum < this.state.selectedOrder.minlot) {
                let minSumTxt = new Intl.NumberFormat().format(this.state.selectedOrder.minlot);
                minLotMark = <RB.InputGroup.Addon style={{ minWidth: '5px', cursor: 'help' }} title={"Минимально допустимая сумма: " + minSumTxt}><RB.Glyphicon glyph="warning-sign" /></RB.InputGroup.Addon>
            }
            else if (this.state.form.sum > this.state.selectedOrder.sumavail) {
                let maxSumTxt = new Intl.NumberFormat().format(this.state.selectedOrder.sumavail);
                minLotMark = <RB.InputGroup.Addon style={{ minWidth: '5px', cursor: 'help' }} title={"Максимальная сумма: " + maxSumTxt}><RB.Glyphicon glyph="warning-sign" /></RB.InputGroup.Addon>
            }
        }

        let dealTake = this.state.form && canTake && this.state.selectedOrder ?
            <RB.Row>
                <RB.Col sm={3} className='otc-inp-label'>
                    {'Сумма:'}
                </RB.Col>
                <RB.Col sm={4}>
                    <RB.FormGroup validationState={this.state.result_is_ok == undefined || this.state.result_is_ok ? (minLotMark ? "warning" : undefined) : "error"}>
                        <RB.InputGroup>
                            {minLotMark}
                            <Cleave name="sum" className="form-control input-numeral" value={this.state.form.sum} placeholder="Сумма"
                                options={{ numeral: true, numericOnly: true, numeralThousandsGroupStyle: 'thousand', numeralDecimalScale: 0, numeralPositiveOnly: true }}
                                onChange={this.handleChange} />

                            <RB.InputGroup.Addon>{this.state.selectedOrder.lotcurrency}</RB.InputGroup.Addon>
                        </RB.InputGroup>
                    </RB.FormGroup>
                </RB.Col>

                <RB.Col sm={2} smOffset={1} className="text-center">
                    {
                        canTrade ? 
                            <RB.Button type="submit" bsSize="sm" bsStyle="primary" disabled={!takeBntEnabled}>{buyCaption}</RB.Button>
                            : undefined
                    }
                </RB.Col>
            </RB.Row>
            : undefined;
    
        var wellTitleClass = 'rep_welltitle';
        let suspendCover = undefined;
        if (this.state.instrument && this.state.instrument.iavail) {
            if (this.state.instrument.iavail.readonly) {
                wellTitleClass = wellTitleClass + ' readonly';
                hdrContent = <div><b>Детализация по ставке{' [ReadOnly]'}</b></div>
            }
            if (!this.state.instrument.iavail.suspended && !this.state.instrument.iavail.tradeopen) {
                wellTitleClass = wellTitleClass + ' passive';
            }
            if (this.state.instrument.iavail.suspended)
                suspendCover = <div className='otc-coverdim'>
                    <span>Торги приостановлены</span>
                </div>
        }
        else {
            wellTitleClass = wellTitleClass + ' passive';
        }


        
        let resultCap =
            this.state.isSubmitting ?
                <div>{"Отправка данных"}</div>
                : this.state.submitted ?
                    (this.state.result_is_ok === undefined ? ""
                        : this.state.result_is_ok ?
                            <div><RB.Glyphicon glyph="ok" />{" "}{this.state.result}</div>
                            : <div><RB.Glyphicon glyph="exclamation-sign" />{" "}{this.state.result}</div>
                    )
                    : "";

//        <Intl.FormattedNumber value={this.state.selectedOrder.discount / 100.0} style="percent" minimumFractionDigits={2} maximumFractionDigits={2} />
//        <RB.FormControl name="sum" type="text" onChange={this.handleChange} value={this.state.form.sum} placeholder="sum" />
        //<RB.FormControl className="input-numeral" disabled={true} name="discount" type="text" onChange={this.handleChange} value={this.state.selectedOrder.discount} placeholder="discount" />

        //<RB.Well bsSize="sm" style={{ maxHeight: '310px' }}>

        let discFmt = <IntlR.FormattedNumber value={this.state.selectedOrder ? this.state.selectedOrder.discount : 0} minimumFractionDigits={2} maximumFractionDigits={2} />;

        return <div ref="cmpDoMDetailsRef" >
            <RB.Row>
                <RB.Col sm={12} >
                    <RB.Well bsSize="sm" style={{ position: 'relative' }}>
                        {suspendCover}
                        <RB.ButtonToolbar className={wellTitleClass}>
                            <RB.ButtonGroup bsSize="xsmall">
                                {hdrContent}                                
                            </RB.ButtonGroup>
                            {canTrade ?
                                <RB.ButtonGroup bsSize="xsmall">
                                    <RB.Button title='Продать все' disabled={true} onClick={this.handleSellAll.bind(this, undefined)}><RB.Glyphicon glyph="remove" />Продать все</RB.Button>
                                </RB.ButtonGroup>
                            : undefined}
                            {canTrade ?
                                <RB.ButtonGroup bsSize="xsmall">
                                    <RB.Button title='Купить все' disabled={true} onClick={this.handleBuyAll.bind(this, undefined)}><RB.Glyphicon glyph="remove" />Купить все</RB.Button>
                                </RB.ButtonGroup>
                            : undefined}

                        </RB.ButtonToolbar>

                        {showData ? 
                            <div>
                        <RB.Row>
                            <RB.Col sm={12}>
                                {hdrContent2}
                            </RB.Col>
                        </RB.Row>
                                <div>{contents} </div>                        
                            </div>
                            : undefined
                         }

                        {showData ?
                            <RB.Form horizontal method="post" onSubmit={this.submit}>
                                <input type="hidden" name="requestVerificationToken" defaultValue={this.props.xsrfToken} />
                                <fieldset style={{ backgroundColor: '#d0eef3' }}>
                                    {acceptInfo1}
                                    {this.state.form && this.state.selectedOrder ?
                                        canTake ? <div>
                                            <RB.Row>
                                                <RB.Col sm={3}>
                                                    {'Дисконт:'}
                                                </RB.Col>
                                                <RB.Col sm={2} style={{ textAlign: 'right' }}>
                                                    <IntlR.FormattedNumber value={this.state.selectedOrder.discount / 100.0} style="percent" minimumFractionDigits={2} maximumFractionDigits={2} />
                                                </RB.Col>
                                                <RB.Col sm={5} smOffset={2}>
                                                    <b>{'Название:'}</b>{this.state.selectedOrder.secfullname}
                                                </RB.Col>
                                            </RB.Row>
                                            <RB.Row>
                                                {this.state.selectedOrder.minlot > 0 ?
                                                    <div>
                                                        <RB.Col sm={3}>
                                                            {'Мин. лот:'}
                                                        </RB.Col>
                                                        <RB.Col sm={2} style={{ textAlign: 'right' }}>
                                                            <IntlR.FormattedNumber value={this.state.selectedOrder.minlot} minimumFractionDigits={0} maximumFractionDigits={0} />
                                                        </RB.Col>
                                                        <RB.Col sm={1}>
                                                            {this.state.selectedOrder.lotcurrency}
                                                        </RB.Col>

                                                    </div>
                                                    :
                                                    <RB.Col sm={6}>
                                                        {''}
                                                    </RB.Col>
                                                }
                                                <RB.Col sm={5} smOffset={1}>
                                                    <b>{'SECID:'}</b>{this.state.selectedOrder.secticker}
                                                </RB.Col>
                                            </RB.Row>
                                        </div>
                                            :
                                            <div>
                                                <RB.Row style={{ paddingTop: '2px' }}>
                                                    <RB.Col sm={5}>
                                                        {''}
                                                    </RB.Col>
                                                    <RB.Col sm={5} smOffset={2}>
                                                        <b>{'Название:'}</b>{this.state.selectedOrder.secfullname}
                                                    </RB.Col>
                                                </RB.Row>
                                                <RB.Row>
                                                    <RB.Col sm={5}>
                                                        {''}
                                                    </RB.Col>
                                                    <RB.Col sm={5} smOffset={2}>
                                                        <b>{'SECID:'}</b>{this.state.selectedOrder.secticker}
                                                    </RB.Col>
                                                </RB.Row>
                                            </div>
                                        : undefined
                                    }
                                </fieldset>
                                <fieldset style={{ paddingTop: '5px' }}>
                                    {dealTake}
                                    <hr />
                                    <RB.FormGroup>
                                        <RB.Col sm={11} className="text-center">
                                            <div>
                                                {resultCap}
                                            </div>
                                        </RB.Col>
                                    </RB.FormGroup>
                                </fieldset>
                            </RB.Form>
                            :
                            undefined
                        }

                    </RB.Well>
                </RB.Col>
            </RB.Row>
        </div>;



        //<RB.FormGroup>
        //    <RB.Col sm={4} >
        //        {'Инструмент:'}
        //    </RB.Col>
        //    <RB.Col sm={7} smOffset={1}>
        //        <RB.DropdownButton
        //            bsStyle={"default".toLowerCase()}
        //            title={sIns != null ? sIns[0].name : "Инструмент"}
        //            key={"fiid"}
        //            name={"fiid"}
        //            id={"fiid"}
        //            onSelect={this.handleFiidSelect}
        //        >
        //            {this.props.instruments.map(ins =>
        //                <RB.MenuItem key={"mi_" + ins.fiid} value={ins.fiid} eventKey={ins.fiid} active={ins.fiid == (this.state.form ? this.state.form.fiid : '') ? true : false}>{ins.name}</RB.MenuItem>
        //            )}
        //        </RB.DropdownButton>
        //    </RB.Col>
        //</RB.FormGroup>

        //    <RB.FormGroup>
        //        <RB.Col sm={4} >
        //            {'Направление:'}
        //        </RB.Col>
        //        <RB.Col sm={7} smOffset={1}>

        //            <RB.ToggleButtonGroup
        //                type="radio"
        //                name="ordertype"
        //                id="ordertype"
        //                value={this.state.form.type}
        //                onChange={this.handleTypeChange}
        //            >
        //                <RB.ToggleButton value={"buy"} onClick={this.handleTypeChange.bind(this, 'buy')}>BUY</RB.ToggleButton>
        //                <RB.ToggleButton value={"sell"} onClick={this.handleTypeChange.bind(this, 'sell')}>SELL</RB.ToggleButton>
        //            </RB.ToggleButtonGroup>
        //        </RB.Col>
        //    </RB.FormGroup>

        //    <RB.FormGroup>
        //        <RB.Col sm={4} >
        //            {'Ставка:'}
        //        </RB.Col>

        //        <RB.Col sm={7} smOffset={1}>
        //            <RB.FormControl name="rate" type="number" min="0" max="100" step="0.1" data-number-to-fixed="2" data-number-stepfactor="100" onChange={this.handleChange} value={this.state.form.rate} placeholder="rate" />
        //        </RB.Col>
        //    </RB.FormGroup>

        //    <RB.FormGroup>
        //        <RB.Col sm={4} >
        //            {'Сумма:'}
        //        </RB.Col>

        //        <RB.Col sm={7} smOffset={1}>
        //            <RB.FormControl name="sum" type="number" min="0" step="1000" data-number-to-fixed="2" data-number-stepfactor="100" onChange={this.handleChange} value={this.state.form.sum} placeholder="sum" />
        //        </RB.Col>
        //    </RB.FormGroup>

        //    <RB.FormGroup>
        //        <RB.Col sm={4} >
        //            {'Дисконт:'}
        //        </RB.Col>

        //        <RB.Col sm={7} smOffset={1}>
        //            <RB.FormControl name="discount" type="number" min="0" max="100" step="0.1" data-number-to-fixed="2" data-number-stepfactor="100" onChange={this.handleChange} value={this.state.form.discount} placeholder="discount" />
        //        </RB.Col>
        //    </RB.FormGroup>

        //    <RB.FormGroup>

        //        <RB.Col sm={6} >
        //            {selectedSetFrm}
        //        </RB.Col>

        //        <RB.Col sm={5} smOffset={1} className="text-center">
        //            <RB.Button type="submit" bsSize="sm" bsStyle="primary" disabled={this.state.isSubmitting || !this.state.selectedSec}>{buyCaption}</RB.Button>
        //        </RB.Col>
        //    </RB.FormGroup>
        //    <hr />
        //    <RB.FormGroup>
        //        <RB.Col sm={11} className="text-center">


        //            <RB.FormControl.Static>
        //                {resultCap}
        //            </RB.FormControl.Static>
        //        </RB.Col>
        //    </RB.FormGroup>

    }

    private renderOrdersTable(records: DTO.RecordOrder[], processing: boolean, selected_locatorId?: string) {

        return <table className='table table-header-fixed table-condensed'>
            <thead>
                <tr style={{ width: 'calc(100% - 5px)' }}>
                    <th style={{ textAlign: 'right', width: '15%' }}>Лот</th>
                    <th style={{ textAlign: 'right', width: '10%' }}>Тип</th>
                    <th style={{ textAlign: 'right', width: '15%' }}>Сумма</th>
                    <th style={{ textAlign: 'right', width: '15%' }}>Валюта</th>
                    <th style={{ textAlign: 'right', width: '15%' }}>Тикер</th>
                    <th style={{ textAlign: 'right', width: '15%' }}>Дисконт, %</th>
                    <th style={{ textAlign: 'right', width: '15%' }}>Контрагент</th>
                </tr>
            </thead>
            <tbody style={{ height: '100px' }}>
                {records.map((orderrecord, i) =>
                    <OrderRecordDeal key={orderrecord.manipulation.locatorId} record={orderrecord} xsrfToken={this.props.xsrfToken} {...initialstate_orderrecord} modified={orderrecord.manipulation.justChanged ? orderrecord.manipulation.justChanged : false}
                        processing={processing} orderSelected={this.handleSelectContext.bind(this)}
                        no={i+1} 
                        selected={this.state.selected_locatorId == orderrecord.manipulation.locatorId} />
                )}
            </tbody>
        </table>;
    }


}





type OrderRecordProps = Actions.OrderState & { xsrfToken?: string } & { record: DTO.RecordOrder } & { orderSelected: any } & {no: number};

const initialstate_orderrecord: Actions.OrderState = {
    processing: false,
    haserrors: false,
    modified: false,
    selected: false
}



class OrderRecordDeal extends React.Component<OrderRecordProps, Actions.OrderState> {
    constructor(props: OrderRecordProps) {
        super(props);
        this.state = {
            ...initialstate_orderrecord, ...{ processing: props.processing, haserrors: props.haserrors, modified: props.modified }
        };
    }

    dispatch = (action: Actions.OrderAction) => {
        return Dispatch.OrderDispatcher(this, action);
    }


    _accept = (locator: { locatorId: string }) => {
        //console.log('_repeal = ');
        //console.log(locator);

        let manipulation: DTO.ManipulationAction<string> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_TAKE,
            locatorId: locator.locatorId,
            payload: undefined
        }

        return Actions.orderActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatch);
    }

    componentWillReceiveProps(nextProps: OrderRecordProps) {
        this.setState(nextProps);
    }

    _onSelectOrder = (locatorId: string, record: DTO.RecordOrder) => {
        let manipulation: DTO.ManipulationAction<string> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_CONTEXT,
            locatorId: locatorId,
            payload: undefined
        }

        return this.props.orderSelected(locatorId, record);
        //return Actions.orderActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatch);
    }

    public render() {
        let bg_color = this.state.processing ? '#7c8887' : (this.state.selected ? undefined : 'white');

        let animation_mod = this.state.modified ? { animation: 'newdata_blink_green 1s 10' } : {}

        let crsr = this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_CONTEXT) ? { cursor: 'pointer' } : {};

        let trStyle: React.CSSProperties = {
            ...{ textAlign: 'right' }, ...{ backgroundColor: bg_color }, ...crsr, ...animation_mod
        };

        var trClass = this.state.selected ? 'rowselected' : undefined;

        let notemark = this.props.record.proto ? <RB.Glyphicon glyph="comment" /> : undefined;

        let popoverNote =
            <RB.Popover id="popover-note" title={'Заявка ' + this.props.record.orderno} style={{ minWidth: '200px', fontSize: '12px' }}>
                <div>
                    <span><strong>{'Комментарий : '}</strong>{' '}{this.props.record.proto.comment}</span>
                </div>
            </RB.Popover>;


        let noteInfo = this.props.record.proto.comment && this.props.record.proto.comment.trim().length > 0
            ?
                <RB.OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement="bottom"
                    overlay={popoverNote}
                    delayShow={500}
                >
                    <span>{notemark}</span>
                </RB.OverlayTrigger>
            :
                undefined;

        return <tr key={this.props.record.manipulation.locatorId} className={trClass} style={trStyle} onClick={this._onSelectOrder.bind(this, this.props.record.manipulation.locatorId, this.props.record)}>
            <td style={{ textAlign: 'right', width: '15%' }} >
                {this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_TAKE) && !this.state.selected ?
                    <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'}>
                        <RB.Button title='Акцепт полного лота' disabled={this.state.processing}
                            onClick={this._accept.bind(this, { locatorId: this.props.record.manipulation.locatorId })}
                        ><RB.Glyphicon glyph="plus" />{noteInfo}</RB.Button>                        
                    </RB.ButtonGroup>
                    : this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_TAKE) && this.state.selected ?
                        <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'}>
                            <RB.Glyphicon glyph="menu-right" />{noteInfo}
                        </RB.ButtonGroup>
                        :
                        <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'}>
                            <RB.Glyphicon glyph="ban-circle" title='Операции недоступны' />{noteInfo}
                        </RB.ButtonGroup>

                }
                {this.props.no}
            </td>
            <td style={{ textAlign: 'right', width: '10%' }}> {this.props.record.lottype}</td>
            <td style={{ textAlign: 'right', width: '15%' }}> {<IntlR.FormattedNumber value={this.props.record.sumavail} minimumFractionDigits={0} maximumFractionDigits={0} />}</td>
            <td style={{ textAlign: 'right', width: '15%' }}> {this.props.record.lotcurrency}</td>
            <td style={{ textAlign: 'right', width: '15%' }}> {this.props.record.secticker}</td>
            <td style={{ textAlign: 'right', width: '15%' }}> {<IntlR.FormattedNumber value={this.props.record.discount / 100.0} style="percent" minimumFractionDigits={2} maximumFractionDigits={2} />}</td>
            <td style={{ textAlign: 'right', width: '15%' }}> {this.props.record.contragent}</td>
        </tr>
            ;
    }

}




interface SubmitNewDealFormAction {
    type: 'SUBMIT_NEW_DEAL_FORM'
    payload: DTO.NewOrderAccept
}

interface NewDealFormRecievedAction {
    type: 'NEW_DEAL_RECIEVED',
    payload: {
        form: DTO.OrderAccept,
        result: string;
    }
}

interface ResetNewDealFormAction {
    type: 'RESET_NEW_DEAL_FORM'
}


interface NewDealFormErrorAction {
    type: 'NEW_DEAL_FORM_ERROR',
    payload: {
        form: DTO.NewOrderAccept,
        errors?: any;
        result: string;
    }
}

type NewDealAction = SubmitNewDealFormAction | NewDealFormRecievedAction | ResetNewDealFormAction | NewDealFormErrorAction;


const stateforwarder = (state: DoMRowDetailState, action: NewDealAction) => {
    switch (action.type) {
        case 'SUBMIT_NEW_DEAL_FORM':
            //console.log('do SUBMIT_NEW_DEAL_FORM');
            return {
                form: action.payload,
                isSubmitting: true,
                submitted: false,
                result_is_ok: undefined
            };
        case 'NEW_DEAL_RECIEVED':
            //console.log('do NEW_DEAL_RECIEVED');
            return {
                //form: initialForm,
                isSubmitting: true,
                submitted: true,
                result_is_ok: true,
                result: action.payload.result
            };
        case 'NEW_DEAL_FORM_ERROR':
            //console.log('do NEW_DEAL_FORM_ERROR');
            return {
                form: action.payload.form,
                isSubmitting: false,
                submitted: true,
                result_is_ok: false,
                result: action.payload.result
            };
        case 'RESET_NEW_DEAL_FORM':
            //console.log('do RESET_NEW_DEAL_FORM');
            return {
                form: initialForm,
                isSubmitting: false,
                submitted: false,
                result: '',
                //seclookupoptions: [],
                selectedOrder: undefined,
                result_is_ok: undefined,
                selected_locatorId: undefined

            };
        default:
        const exhaustiveCheck: never = action;
    }


    return state;
};

